module.exports = __webpack_public_path__ + "img/grafica_inversion.647c7ea6.png";